/**
 * Lo que arma la pantalla de tareas del cliente antes de mandarlo. PURO.
 */

export interface RespuestaDeModelo {
  nombre: string;
  meses?: number;
  noEsModelo?: boolean;
}

/** Meses válidos: un entero de 1 a 120. */
export function mesesValidos(texto: string | undefined): number | null {
  const n = Number((texto ?? '').trim());
  return Number.isInteger(n) && n >= 1 && n <= 120 ? n : null;
}

/**
 * Las respuestas que se mandan: con meses válidos o marcadas «no es un modelo».
 * Lo que quedó vacío o mal escrito no se manda: sigue esperando.
 */
export function armarRespuestasDeModelos(
  pendientes: string[],
  meses: Record<string, string>,
  noEsModelo: Record<string, boolean>,
): RespuestaDeModelo[] {
  const respuestas: RespuestaDeModelo[] = [];
  for (const nombre of pendientes) {
    if (noEsModelo[nombre]) {
      respuestas.push({ nombre, noEsModelo: true });
      continue;
    }
    const m = mesesValidos(meses[nombre]);
    if (m !== null) respuestas.push({ nombre, meses: m });
  }
  return respuestas;
}

/** Pone un valor en los modelos que siguen vacíos (el «todos con 12»). No pisa lo ya escrito. */
export function llenarVacios(
  pendientes: string[],
  meses: Record<string, string>,
  noEsModelo: Record<string, boolean>,
  valor: string,
): Record<string, string> {
  const siguiente = { ...meses };
  for (const nombre of pendientes) {
    if (!noEsModelo[nombre] && !(siguiente[nombre] ?? '').trim()) siguiente[nombre] = valor;
  }
  return siguiente;
}

export interface GrupoParaAprobar {
  clave: string;
  variantes: { zona: string; trabajos: number }[];
}

/** Lo que se manda al aprobar las zonas: cada grupo con el destino elegido. */
export function armarAprobacionDeZonas(
  grupos: GrupoParaAprobar[],
  destinos: Record<string, string>,
): { variantes: string[]; destino: string }[] {
  return grupos
    .map((g) => ({
      variantes: g.variantes.map((v) => v.zona),
      destino: (destinos[g.clave] ?? '').trim(),
    }))
    .filter((g) => g.destino !== '');
}

/** Cuántos trabajos viejos cambian de zona con esas elecciones. */
export function trabajosQueCambian(
  grupos: GrupoParaAprobar[],
  destinos: Record<string, string>,
): number {
  let total = 0;
  for (const g of grupos) {
    const destino = (destinos[g.clave] ?? '').trim();
    if (!destino) continue;
    for (const v of g.variantes) if (v.zona !== destino) total += v.trabajos;
  }
  return total;
}
